import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize } from 'rxjs/operators';
import { SharedModule } from '../../../../shared/shared.module';
import { BankAccountPropertiesComponent } from '../bank-account-properties/bank-account-properties.component';
import { GrowlerService } from '../../../../shared/growler/growler.service';
import { BankAccountsService } from '../../../../../services/financial-accounts/bank-accounts.service';
import { ValidationMessageService } from '../../../../../services/validation-message.service';

export interface AddOrgBankAccountDialogInput
{
    onlyDepositAccounts?: boolean;
}

export interface AddOrgBankAccountDialogResult
{
    success: boolean;
}

@UntilDestroy()
@Component({
    selector: 'app-add-org-bank-account-dialog',
    templateUrl: './add-org-bank-account-dialog.component.html',
    standalone: true,
    imports: [
        SharedModule,
        BankAccountPropertiesComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AddOrgBankAccountDialogComponent
{
    @Input() open = false;
    @Input() data: AddOrgBankAccountDialogInput = {};
    @Output() closed = new EventEmitter<AddOrgBankAccountDialogResult>();

    @ViewChild('propertiesForm') propertiesForm: BankAccountPropertiesComponent;

    isSaving = false;

    constructor(
            private _bankAccountsService: BankAccountsService,
            private _growler: GrowlerService,
            private _validationMessageService: ValidationMessageService,
    ) {
    }

    saveAccount() {
        if (!this.propertiesForm.isValid()) {
            return;
        }

        const request = this.propertiesForm.getFormValue();

        this.isSaving = true;
        this._bankAccountsService.createOrganizationBankAccount(
                null,
                request,
        ).pipe(
                finalize(() => this.isSaving = false),
                untilDestroyed(this),
        ).subscribe({
            next: () => {
                this.closed.emit(<AddOrgBankAccountDialogResult>{
                    success: true,
                });
                this._growler.success('Success', 'We have successfully added your bank account');
            },
            error: (error) => {
                this._growler.oops(this._validationMessageService.extractResponseErrorText(error));
            },
        });
    }

    closeDialog() {
        this.closed.emit(<AddOrgBankAccountDialogResult>{success: false});
    }
}
